// Names from artifacts/Client_Operations_Reference.md, "Feed Types Progression".
const FEED_TYPES: ReadonlyArray<readonly [code: string, name: string]> = [
  ['7701', 'Starter'],
  ['7702', 'Early Grower'],
  ['7703', 'Grower'],
  ['7703P', 'Premium Grower'],
  ['7704S', 'Small Finisher'],
  ['7704', 'Finisher'],
];

export const FEED_TYPE_OPTIONS = FEED_TYPES.map(([value, name]) => ({
  value,
  label: `${value} (${name})`,
}));

// Recommendations can be blends such as "7701 + 7702". Null when any code is unknown.
export function feedTypeNames(code: string): string | null {
  const names = code.split('+').map((part) => FEED_TYPES.find(([c]) => c === part.trim())?.[1]);
  return names.every((name): name is string => !!name) ? names.join(' + ') : null;
}

/** "90% 7701 + 10% 7702" for a blended feeding, else its single feed type (#361). */
export function feedLabel(f: { feed_type?: string | null; blend?: ReadonlyArray<{ feed_type: string; percent: number | string }> | null }): string | null {
  if (f.blend && f.blend.length > 0) {
    return f.blend.map((b) => `${Math.round(Number(b.percent) * 100) / 100}% ${b.feed_type}`).join(' + ');
  }
  return f.feed_type ?? null;
}
